var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "bg-white py-8 border-b-2 border-gray-300" }, [
      _c(
        "div",
        {
          staticClass:
            "w-full md:w-10/12 mx-auto flex justify-between px-4 md:px-0"
        },
        [
          _vm._m(0),
          _vm.isWorking
            ? _c("span", {
                staticClass: "mdi mdi-loading mdi-spin text-5xl text-gray-500"
              })
            : _vm._e(),
          !_vm.isWorking
            ? _c("div", { staticClass: "flex items-center" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "bg-red-200 hover:bg-red-300 text-red-900 font-semibold py-2 pl-3 pr-4 border border-red-400 rounded hover:shadow inline-flex items-center",
                    on: {
                      click: function($event) {
                        return _vm.$authService.logout()
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "fill-current w-6 h-6 mr-2",
                        attrs: { viewBox: "0 0 24 24" }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z"
                          }
                        })
                      ]
                    ),
                    _c("span", [_vm._v("Logout")])
                  ]
                )
              ])
            : _vm._e()
        ]
      )
    ]),
    _c("section", { staticClass: "py-8" }, [
      _c(
        "div",
        { staticClass: "w-full md:w-10/12 mx-auto flex flex-col px-4 md:px-0" },
        [
          !_vm.isWorking
            ? _c(
                "div",
                {
                  staticClass:
                    "bg-red-200 border-l-4 border-red-600 rounded pl-4 py-6 text-red-900 flex items-center"
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "fill-current h-12 w-12 mr-4",
                      attrs: { viewBox: "0 0 24 24" }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
                        }
                      })
                    ]
                  ),
                  _vm._m(1)
                ]
              )
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "flex w-full md:w-2/3 lg:w-1/2 flex-col justify-center items-start"
      },
      [
        _c("h2", { staticClass: "font-bold text-2xl" }, [
          _vm._v("Logging You In")
        ]),
        _c("h3", { staticClass: "text-xl text-gray-600 mr-5 mt-5" }, [
          _vm._v("Please wait while we log you in.")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", { staticClass: "text-2xl font-bold" }, [_vm._v("Oops")]),
      _c("h3", { staticClass: "text-lg" }, [
        _vm._v(
          "Sorry, there has been an error logging you in. Please try again later or contact our support team."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }